module.exports = __webpack_public_path__ + "static/media/charging-system-components.5ef56211.png";